import classnames from "classnames";
import { Tooltip } from "../../../components/tooltip/tooltip";
import { NumberField } from "../../../components/form-inputs/inputs";
import React from "react";

export const ErrorNumberInput = ({ displayZero, fieldState, formState, ...props }) => {
    const warningMessage = formState.errors ? formState.errors?.[`${props.name}Warning`]?.message : undefined;
    const errorMessage = fieldState.error ? fieldState.error.message : undefined;

    const getDisplayMessage = () => {
        if (errorMessage) {
            return errorMessage;
        } else if (warningMessage) {
            return warningMessage;
        }

        return undefined;
    };

    return (
        <>
            <Tooltip
                asWarning={errorMessage ? undefined : warningMessage}
                asError={errorMessage}
                text={getDisplayMessage()}
                classes="m-r-4"
            >
                <NumberField
                    {...props}
                    displayZero={displayZero}
                    className={classnames({
                        "-error": errorMessage,
                        "-warning": warningMessage,
                        "m-r-16": true,
                    })}
                />
            </Tooltip>
        </>
    );
};
